import axios from "axios";
import { DateTime } from "luxon";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setConsumi } from "../../../features/gasSlice";
import "./_viewYear.scss";
import { CircularProgress } from "@mui/material";
import BarContainer from "./_barContainer";
import ListGas from "./_list";
import GasFilter from "./_filter";

function ViewGas() {
  const dispatch = useDispatch();
  const userNameGas = useSelector((user) => user?.user?.podsList[0]?.username);
  const customerCode = useSelector((user) => user.gas?.info?.customer_code);
  const [loading, setLoading] = useState(true);
  const data = useSelector((user) => user.gas?.consumi);
  const maxValueArray = data && data.map((r) => parseFloat(r.consumo_mc));
  const maxValue = maxValueArray && Math.max(...maxValueArray);
  const [year, setYear] = useState(DateTime.now().toFormat("y"));
  const [yearPrevious, setYearPrevious] = useState(DateTime.now().plus({ year: -1 }).toFormat('y'))
  const [lastYear, setLastYear] = useState(DateTime.now().toFormat('y'))

  useEffect(() => {
    init();
  }, [customerCode]);

  const init = async () => {
    const deliveryApi = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getDeliveryGas.php?codice_cliente=${customerCode}`;
    await axios.get(deliveryApi).then(({ data }) => {
      data.success
        ? dispatch(setConsumi(data.data)) && setLoading(false)
        : setLoading(false);
    });
  };
  const goBack = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    setYear(DateTime.fromFormat(year, "y").plus({ year: -1 }).toFormat("y"));
    setYearPrevious(
      DateTime.fromFormat(yearPrevious, "y").plus({ year: -1 }).toFormat("y")
    );
  };
  const goForward = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    setYear(
      DateTime.fromFormat(year, "y")
        .plus({ year: +1 })
        .toFormat("y")
    );
    setYearPrevious(
      DateTime.fromFormat(yearPrevious, "y")
        .plus({ year: +1 })
        .toFormat("y")
    );
  };
  return (
    <div className="year">
      <div
        className="year_graph"
        style={
          loading ? { alignItems: "center", justifyContent: "center" } : null
        }
      >
        {loading ? (
          <div className="loader">
            <CircularProgress />
          </div>
        ) : (
          <>
            <div className="backgroundLine">
              <div className="line"></div>
              <div className="line"></div>
              <div className="line"></div>
            </div>
            {/* <BarIndex maxEuroValue={maxEuroValue} /> */}
            <div className="year_graph-wrapper">
              {data &&
                data
                  .filter((r) => r.mese.includes(year))
                  .map((d, i) => (
                    <BarContainer key={i} data={d} maxValue={maxValue} />
                  ))}
            </div>
          </>
        )}
      </div>
      <GasFilter lastYear={lastYear}  data={data} year={year} goBack={() => goBack()} goForward={() => goForward()} yearPrevious={yearPrevious} />
      <ListGas data={data} year={year} />
    </div>
  );
}

export default ViewGas;
